/**
 * @generated SignedSource<<f345056cae6a3c506267e4ed5e36de73>>
 * @relayHash f93033cffdcd46fef6b993e9e7fb638b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 519dc55cf9d7e1c97959e5b0de6dfd9ab681a8083e2d82c4a905f98b9fb93cc1

import type { ConcreteRequest } from 'relay-runtime';
export type StudioCustomSkillRendererQuery$variables = {
  contextAri: string;
  skillAri: string;
};
export type StudioCustomSkillRendererQuery$data = {
  readonly graphIntegration_skill: {
    readonly description: string;
    readonly instructions: string;
    readonly name: string;
    readonly uiMetadata: {
      readonly displayName: string;
    };
  } | null;
};
export type StudioCustomSkillRendererQuery = {
  response: StudioCustomSkillRendererQuery$data;
  variables: StudioCustomSkillRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "contextAri",
    "variableName": "contextAri"
  },
  {
    "kind": "Variable",
    "name": "skillAri",
    "variableName": "skillAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "kind": "ScalarField",
  "name": "instructions"
},
v6 = {
  "concreteType": "GraphIntegrationSkillUiMetadata",
  "kind": "LinkedField",
  "name": "uiMetadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StudioCustomSkillRendererQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "GraphIntegrationSkill",
        "kind": "LinkedField",
        "name": "graphIntegration_skill",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StudioCustomSkillRendererQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "GraphIntegrationSkill",
        "kind": "LinkedField",
        "name": "graphIntegration_skill",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "519dc55cf9d7e1c97959e5b0de6dfd9ab681a8083e2d82c4a905f98b9fb93cc1",
    "metadata": {},
    "name": "StudioCustomSkillRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e8cc900bb2336a9a3c669633118ce55b";

export default node;
